import React from 'react';
import { ScrollLock } from '@atlassian/jira-portfolio-3-common';
import { useIsColumnDragging } from '../hooks/use-is-column-dragging';

export const ColumnDragScrollLock = () => {
	const isColumnDragging = useIsColumnDragging();

	return <ScrollLock axis="vertical" enabled={isColumnDragging} />;
};
